import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Styles/footer.css";
import { IMAGES } from "../utils/images";
import axios from "axios";
import { country_data } from "../utils/countryCodes";

const Footer = ({ title, content, btnText }) => {
  // API URL - use environment variable or default to the production URL
  const API_URL = process.env.REACT_APP_API_URL || 'https://srim-edutech-api.onrender.com';
  
  // State for modal visibility
  const [showModal, setShowModal] = useState(false);
  // State for form data
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    course: "",
    message: "Join Now request",
    agreedToPrivacyPolicy: true
  });
  // State for country code selection
  const [countryEmoji, setCountryEmoji] = useState("🇮🇳");
  const [countryCode, setCountryCode] = useState("+91");
  // State for form submission
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle country code selection
  const handleCountryChange = (e) => {
    try {
      const selectedOption = JSON.parse(e.target.value);
      setCountryEmoji(selectedOption.flag);
      setCountryCode(selectedOption.code);
    } catch (err) {
      console.error('Error parsing country option:', err);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    
    try {
      // Format phone number with country code
      const formattedData = {
        ...formData,
        mobile: `${countryCode} ${formData.mobile}`
      };
      
      console.log('Submitting data to API:', `${API_URL}/api/contact`, formattedData);
      
      // Send data to backend API
      const response = await axios.post(`${API_URL}/api/contact`, formattedData, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      });
      
      // Handle success
      setSuccess(true);
      setFormData({
        name: "",
        email: "",
        mobile: "",
        course: "",
        message: "Join Now request",
        agreedToPrivacyPolicy: true
      });
      
      // Close modal after 2 seconds on success
      setTimeout(() => {
        setShowModal(false);
        setSuccess(false);
      }, 2000);
      
    } catch (err) {
      console.error('Error submitting join request:', err);
      setError(err.response?.data?.error || 'Failed to submit request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Modal close handler
  const closeModal = () => {
    setShowModal(false);
    setError("");
    setSuccess(false);
  };

  // Stop event propagation
  const stopPropagation = (e) => {
    e.stopPropagation();
  };
  
  return (
    <div className="footer">
      <div className="footer-left">
        <h1 className="footer-left-title">{title}</h1>
        <p className="footer-left-content">{content}</p>
        <button className="footer-left-button" onClick={() => setShowModal(true)}>{btnText}</button>
      </div>
      <div className="footer-right">
      <div className="footer-right-top">
        <div className="column">
          <h1 className="links-heading">Links</h1>
          <ul className="links">
            <li className="links-body"><Link to="/" className="link">Home</Link></li>
            <li className="links-body"><Link to="/Training" className="link">Training</Link></li>
            <li className="links-body"><Link to="/AboutUs" className="link">About us</Link></li>
            <li className="links-body"><Link to="/Courses" className="link">Courses</Link></li>
            <li className="links-body"><Link to="/Contact" className="link">Contact</Link></li>
          </ul>
        </div>
        <div className="column">
          <h1 className="links-heading">Courses</h1>
          <ul className="links">
            <li className="links-body"><Link to="/frontend development" className="link-fit">Frontend Development</Link></li>
            <li className="links-body"><Link to="/mern stack" className="link-fit">MERN stack</Link></li>
            <li className="links-body"><Link to="/full stack development" className="link-fit">Full Stack Development</Link></li>
            <li className="links-body"><Link to="/ui&ux design" className="link-fit">UI & UX Design</Link></li>
            <li className="links-body"><Link to="/digital marketing" className="link-fit">Digital Marketing</Link></li>
          </ul>
        </div>
        <div className="column">
          <h1 className="links-heading">Training</h1>
          <ul className="links">
            <li className="links-body"><Link to="/longterm trainings" className="link-fit">Long-Term Trainings</Link></li>
            <li className="links-body"><Link to="/shortterm trainings" className="link-fit">Short-Term Trainings</Link></li>
          </ul>
        </div>
        <div className="logo-image">
          <img src={IMAGES.EDUTECH_LOGO} alt="Logo" />
          <div className="social-media">
          <img src={IMAGES.FACEBOOK_ICON} />
          <img src={IMAGES.TWITTER_ICON} />
          <img src={IMAGES.LINKEDIN_ICON} />
          <img src={IMAGES.INSTAGRAM_ICON} />
        </div>
        </div>
        
        </div>
        <div className="footer-bottom">
        
        <div className="social-media">
        <p className="footer-bottom-text-1">· Terms</p>
        <p className="footer-bottom-text-1">· Privacy</p>
        </div>

        <div className="footer-bottom-text">
          <p className="footer-bottom-text-1">© {new Date().getFullYear()} · SRIM Media</p>
          
        </div>
      </div>
      </div>

      {/* Join Now Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={stopPropagation}>
            <div className="modal-header">
              <h2>Request to Join</h2>
              <button className="close-button" onClick={closeModal}>×</button>
            </div>
            
            {success ? (
              <div className="success-message">
                <p>Thank you for your interest! We'll contact you soon.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter Your Name *"
                    required
                  />
                </div>
                
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter Your Email *"
                    required
                  />
                </div>
                
                <div className="form-group phone-input">
                  <div className="country-selector">
                    <span>{countryEmoji}</span>
                    <select
                      onChange={handleCountryChange}
                      value={JSON.stringify({"flag":countryEmoji,"code":countryCode})}
                    >
                      <option value={JSON.stringify({"flag":"🇮🇳","code":"+91"})}>{countryCode}</option>
                      {country_data.map((item) => (
                        <option key={item.dial_code} value={JSON.stringify({"flag":item.flag,"code":item.dial_code})}>
                          {item.dial_code}
                        </option>
                      ))}
                    </select>
                  </div>
                  <input
                    type="text"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder="Enter Your Mobile Number *"
                    required
                  />
                </div>
                
                <div className="form-group">
                  <input
                    type="text"
                    name="course"
                    value={formData.course}
                    onChange={handleChange}
                    placeholder="Course You're Interested In"
                  />
                </div>
                
                {error && <div className="error-message">{error}</div>}
                
                <button type="submit" className="submit-button" disabled={loading}>
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;

/* Add this CSS to your footer.css file:

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h2 {
  margin: 0;
  font-size: 24px;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.form-group {
  margin-bottom: 15px;
}

.form-group input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.phone-input {
  display: flex;
}

.country-selector {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 4px 0 0 4px;
  padding: 0 10px;
  background-color: #f9f9f9;
}

.country-selector span {
  margin-right: 5px;
}

.country-selector select {
  border: none;
  background: transparent;
  padding: 12px 5px;
  cursor: pointer;
}

.phone-input input {
  border-radius: 0 4px 4px 0;
  border-left: none;
}

.submit-button {
  width: 100%;
  padding: 12px;
  background-color: #6a3de8;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: #5a2ed8;
}

.submit-button:disabled {
  background-color: #a990f0;
  cursor: not-allowed;
}

.success-message {
  text-align: center;
  padding: 20px;
  color: #4CAF50;
  font-size: 18px;
}

.error-message {
  color: #f44336;
  margin-bottom: 15px;
  font-size: 14px;
}
*/
